<template>
	<article class="view-login bg-blue-gradient">
		<div class="site-wrapper flex-row flex-center-h flex-center-v">
			<div class="login-register flex-row flex-center-h">
				<section class="section--login flex-row flex-center-h flex-center-v">
					<header>
						<img role="img" aria-hidden="true" src="@/assets/svg/CrossDoc-monogram.svg" width="100px" />
						<h1>Connexion</h1>
					</header>

					<div class="form-wrapper">
						<form method="post" @submit.prevent="signinUser">
							<div class="input-group">
								<label for="login">Adresse e-mail</label>
								<input type="email" name="login" id="login" v-model="loginData.login" required />
							</div>

							<div class="input-group">
								<label for="password">Mot de passe</label>
								<input type="password" name="password" id="password" v-model="loginData.password" required />
							</div>

							<div class="input-group--controls">
								<button type="submit" class="button--outline">
									<svg
										class="icon"
										role="img"
										xmlns="http://www.w3.org/2000/svg"
										width="18"
										height="18"
										fill="none"
										viewBox="0 0 18 18"
									>
										<path
											fill="currentColor"
											d="M10.8.9a.9.9 0 0 1 .9-.9h3.6A2.7 2.7 0 0 1 18 2.7v12.6a2.7 2.7 0 0 1-2.7 2.7h-3.6a.9.9 0 1 1 0-1.8h3.6a.9.9 0 0 0 .9-.9V2.7a.9.9 0 0 0-.9-.9h-3.6a.9.9 0 0 1-.9-.9z"
										/>
										<path
											fill="currentColor"
											d="M6.564 3.864a.9.9 0 0 1 1.272 0l4.5 4.499.006.007a.897.897 0 0 1 .258.627v.006a.898.898 0 0 1-.258.627l-.006.007-4.5 4.5a.9.9 0 1 1-1.272-1.273L9.527 9.9H.9a.9.9 0 1 1 0-1.8h8.627L6.564 5.136a.9.9 0 0 1 0-1.272z"
										/></svg
									><span class="caption">Connexion</span>
								</button>

								<p><router-link to="/password-reset">Mot de passe oublié&nbsp;?</router-link></p>
							</div>
						</form>
					</div>
				</section>
			</div>
		</div>
	</article>
</template>

<style lang="scss" scoped>
@import "src/scss/login.scss";
</style>

<script>
import {HTTP} from "../http-common";

export default {
	name: "login",

	data: function() {
		return {
			loginData: {
				password: "",
				login: ""
			}
		};
	},

	methods: {
		// Connexion de l'utilisateur
		loginUser: function() {
			this.$store
				.dispatch("USER_LOGIN")
				.then(() => this.$router.push("/dashboard"))
				.catch(err => {
					// Le compte n'est pas vérifié (email opt-in)
					if (err.status === 403)
						return this.$toasted.global.app_error({
							message: "Votre compte n’est pas vérifié, <strong>consultez votre boite mail.</strong>"
						});
					// Erreur d'authentification
					else
						return this.$toasted.global.app_error({
							message:
								"Impossible de vous connecter,<br><strong>vérifiez votre identifiant et votre mot de passe !</strong>"
						});

					// Session expirée
					// this.$toasted.global.app_error({message: "Votre session a expirée, veuillez vous reconnecter."});
				});
		},

		// Authentification et Connexion de l'utilisateur
		signinUser: function() {
			this.$store
				.dispatch("AUTH_REQUEST", this.loginData)
				.then(() => {
					this.$toasted.clear();
					// Authorization Header (JWT)
					// (Si un token est déjà enregistré en localStorage, il est passé à chaque requête.)
					// -> L'authentification (AUTH_REQUEST) s'est déroulée avec succès : on ajoute le token à toutes les requêtes :
					HTTP.defaults.headers.common.Authorization = "Bearer " + this.$store.state.userToken;
					// Maintenant on connecte l'utilisateur
					this.loginUser();
				})
				.catch(error => {
					// TODO: Handle auth error
					// Le compte n'est pas activé (email opt-in)
					this.$toasted.global.app_error({
						message: "Impossible de vous authentifier,<br>vérifiez votre identifiant et votre mot de passe !"
					});
				});
		}
	}
};
</script>
